import React, { useState } from "react";
import useUserStore from "../store/userStore";
import '../styles/Login.scss';
import { TextField, InputAdornment, IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import logo from "../logo.jpg";
import { LoginRequest, CreateLoginRequest } from "../types/User";
import { useNavigate } from "react-router-dom";
import { useLoadingStore } from "../store/loadingStore";
import useToastStore from "../store/toastStore";
export default function Login () {
  // States
  const { login } = useUserStore();
  const [user, setUser] = useState<LoginRequest>(CreateLoginRequest());
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility
  const navigate = useNavigate();
  const {setLoading} = useLoadingStore();
  const {showToast} = useToastStore();
  const handleLogin = async () => {
    setLoading(true)
    await login(user,showToast);
    setLoading(false)
    navigate("/");
  };

  const handlePropertyChange = (value: string, prop: keyof LoginRequest) => {
    setUser((prevUser) => ({
      ...prevUser,
      [prop]: value,
    }));
  };
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      handleLogin();
    }
  };
  const handleClickShowPassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const sx = {
    "& .MuiInput-root": {
      // Normal text color
      color: "lightgray", 
      fontWeight: "light",
      // Bottom border
      "&:before": {
        borderColor: "lightgray", 
        borderWidth: "1px",
      },
      // Border on hover
      "&:hover:not(.Mui-disabled):before": {
        borderColor: "lightgray", 
        borderWidth: "1px",
      },
      // Border on focus
      "&:after": {
        borderColor: "white", 
        borderWidth: "1px",
      },
    },
    // Label
    "& .MuiInputLabel-root": {
      color: "lightgray", 
      fontWeight: "light",
      "&.Mui-focused": {
        color: "white",
      },
    },
    "& .MuiInputBase-input": {
      color: "lightgray", 
      "&:focus": {
        color: "white",
      },
    },
  };

  const iconStyle = {
    color: "white", // Set the icon color to white
  };

  return (
    <div className="loginWrapper" onKeyDown={handleKeyDown}>
      <div className="login">
        <img src={logo} alt="Home Logo" />
        <TextField
          className="loginText"
          label="Username"
          variant="standard"
          sx={sx}
          value={user.username}
          onChange={(e) => handlePropertyChange(e.target.value, "username")}
        />
        <TextField
          className="loginText"
          label="Password"
          variant="standard"
          type={showPassword ? "text" : "password"} // Toggle between text and password
          sx={sx}
          value={user.password}
          onChange={(e) => handlePropertyChange(e.target.value, "password")}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={handleClickShowPassword} edge="end">
                  {showPassword ? (
                    <VisibilityOff sx={iconStyle} />
                  ) : (
                    <Visibility sx={iconStyle} />
                  )}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <button className='loginButton' onClick={handleLogin}>
          ΕΙΣΟΔΟΣ
        </button>
      </div>
    </div>
  );
};

